<template>
  <div>
    <div class="finance-calculator">
      <div class="row">
        <div class="col-lg-12">
          <div class="card finance-border">
            <div class="card-body">
              <v-form @submit.prevent="submitForm">
                <div class="row">
                  <div class="col-md-6">
                    <div class="finance-input">
                      <label for="financial-goal" class="label-spacing"
                        >Financial goal in today's value</label
                      >
                      <span class="finance-group">
                        <div class="rupees-symbol">₹</div>
                        <input
                          type="text"
                          class="form-control"
                          v-model="formData.goal"
                          outlined
                          id="financial-goal"
                        />
                      </span>
                    </div>
                    <div class="finance-input">
                      <label for="time-period" class="label-spacing"
                        >Number of years remaining
                      </label>
                      <span class="finance-group">
                        <button type="button" @click="decreaseTimePeriod">
                          -
                        </button>
                        <input
                          type="text"
                          v-model="formData.time"
                          class="form-control text-center"
                          outlined
                          id="time-period"
                        />
                        <button type="button" @click="increaseTimePeriod">
                          +
                        </button>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="finance-input">
                      <label for="existing-investment" class="label-spacing"
                        >Existing investment for goal</label
                      >
                      <span class="finance-group">
                        <div class="rupees-symbol">₹</div>
                        <input
                          type="text"
                          class="form-control"
                          v-model="formData.existing"
                          outlined
                          id="existing-investment"
                        />
                      </span>
                    </div>
                    <div class="finance-input">
                      <label for="inflation" class="label-spacing"
                        >Expected inflation</label
                      >
                      <span class="finance-group">
                        <button type="button" @click="decreaseReturns">
                          -
                        </button>
                        <input
                          class="form-control text-center"
                          type="text"
                          v-model="formData.inflation"
                          outlined
                          id="inflation"
                        />
                        <button type="button" @click="increaseReturns">
                          +
                        </button>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="finance-input">
                      <label for="time-returns" class="label-spacing"
                        >Expected returns from investments</label
                      >
                      <span class="finance-group">
                        <button type="button" @click="decreaseExpectedReturns">
                          -
                        </button>
                        <input
                          class="form-control text-center"
                          type="text"
                          v-model="formData.returns"
                          outlined
                          id="time-returns"
                        />
                        <button type="button" @click="increaseExpectedReturns">
                          +
                        </button>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-6 mb-0" style="align-content: end">
                    <div class="finance-input">
                      <button
                        type="button"
                        @click="submitForm()"
                        class="finance-button"
                      >
                        Calculate
                      </button>
                    </div>
                  </div>
                  <div></div>
                </div>
              </v-form>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <div class="second-card">
          <div class="row">
            <div class="col-md-4 mb-4">
              <div class="card finance-border-card">
                <div class="card-body finance-card-color">
                  <div class="text-center">
                    <label for="future-goal" class="finance-card-label"
                      >Estimated future<br />goal amount</label
                    >
                  </div>
                  <div class="text-center">
                    <input
                      v-model="estimatedFutureGoal"
                      class="finance-card-input"
                      id="future-goal"
                      readonly
                    />
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div class="col-md-4 mb-4">
              <div class="card finance-border-card">
                <div class="card-body finance-card-color">
                  <div class="text-center">
                    <label for="future-existing" class="finance-card-label"
                      >Future value of<br />existing investment</label
                    >
                  </div>
                  <div class="text-center">
                    <input
                      v-model="formattedFutureAmount"
                      class="finance-card-input"
                      id="future-existing"
                      readonly
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card finance-border-card">
                <div class="card-body finance-card-color">
                  <div class="text-center">
                    <label for="monthly-investgoal" class="finance-card-label"
                      >Monthly investment<br />
                      needed</label
                    >
                  </div>
                  <div class="text-center">
                    <input
                      v-model="monthlyInvestGoal"
                      class="finance-card-input"
                      id="monthly-investgoal"
                      readonly
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="finalValue < 0"
              style="display: block; text-align: center"
            >
              <span class="swp-icon fst-italic">
                <i class="fa fa-times-circle-o" aria-hidden="true"></i>
                <small style=""
                  >Your Investment amount does not support the withdrawal rate
                  kindly change the values to reach an optimal number</small
                >
              </span>
            </div>
            <i class="finance-disclaim"
              >Disclaimer: Results shown for illustrative purpose only and
              should not be construed as investment advice</i
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FinancialGoalCalculator",
  components: {},
  data() {
    return {
      formData: {
        goal: 500000,
        time: "5 Years",
        inflation: "3.5 %",
        current: "",
        returns: "12 %",
        minValue: 0,
        maxValue: 100,
      },
      estimatedFutureGoal: "₹ 5,93,843",
      formattedFutureAmount: "₹ 0",
      futureAmount: "",
      monthlyInvestGoal: "₹ 8,403",
      estimatedFutureCost: " ₹ 0",
      futureCurrentInvestment: "₹ 0",
      formattedAmount: "₹ 0",
      monthlyInvest: "₹ 0",
      currentPage: 1,
      steps: ["Basic Details", "Results"],
    };
  },
  methods: {
    submitForm() {
      this.currentPage++;
      this.calculateTotalValue();
    },
    goToPage(pageNumber) {
      this.currentPage = pageNumber;
    },
    increaseReturns() {
      const numericValue = parseFloat(this.formData.inflation);
      if (numericValue > 3) {
        this.formData.inflation = `${Math.min(numericValue + 0.5, 20)} %`;
      }
    },
    decreaseReturns() {
      const numericValue = parseFloat(this.formData.inflation);
      if (numericValue <= 20.5) {
        this.formData.inflation = `${Math.max(numericValue - 0.5, 3)} %`;
      }
    },
    increaseExpectedReturns() {
      const numericValue = parseFloat(this.formData.returns);
      if (numericValue > 3.5) {
        this.formData.returns = `${Math.min(numericValue + 0.5, 50)} %`;
      }
    },
    decreaseExpectedReturns() {
      const numericValue = parseFloat(this.formData.returns);
      if (numericValue <= 50.5) {
        this.formData.returns = `${Math.max(numericValue - 0.5, 3)} %`;
      }
    },
    calculateTotalValue() {
      const estimatedFutureGoal = Math.round(
        this.formData.goal *
          Math.pow(
            1 + parseFloat(this.formData.inflation) / 100,
            parseFloat(this.formData.time)
          )
      );
      this.estimatedFutureGoal = `₹ ${estimatedFutureGoal.toLocaleString(
        "en-IN"
      )}`;
      if (!isNaN(this.formData.existing) && this.formData.existing !== 0) {
        this.futureAmount = Math.round(
          this.formData.existing *
            Math.pow(
              1 + parseFloat(this.formData.returns) / 100,
              parseFloat(this.formData.time)
            )
        );
        this.formattedFutureAmount = `₹ ${this.futureAmount.toLocaleString(
          "en-IN"
        )}`;
      } else {
        this.formattedFutureAmount = "₹ 0";
      }
      const monthlyInvestGoal = Intl.NumberFormat("en-IN").format(
        Math.round(
          ((estimatedFutureGoal - this.futureAmount) *
            (parseFloat(this.formData.returns) / (100 * 12))) /
            (Math.pow(
              1 + parseFloat(this.formData.returns) / (100 * 12),
              12 * parseFloat(this.formData.time)
            ) -
              1)
        )
      );
      this.monthlyInvestGoal = `₹ ${monthlyInvestGoal.toLocaleString("en-IN")}`;
    },
    increaseTimePeriod() {
      const numericValue = parseInt(this.formData.time);
      if (numericValue < 50) {
        this.formData.time = `${numericValue + 1} Years`;
      }
    },
    decreaseTimePeriod() {
      const numericValue = parseInt(this.formData.time);
      if (numericValue > 1) {
        this.formData.time = `${numericValue - 1} Years`;
      }
    },
  },
};
</script>

<style scoped>
.finance-calculator .finance-input label {
  display: block;
  font-weight: bold;
  text-align: justify;
  font-size: 16px;
  color: #012e40 !important;
}

.finance-group {
  display: flex;
  border: 1px solid #e5e5e5;
  margin: 0 0 10px;
  border-radius: 8px;
  -ms-flex-align: center;
  align-items: center;
}

.finance-group input {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent;
}

.label-spacing {
  margin-bottom: 0.7rem;
}

.finance-border {
  border: none;
  outline: none;
  background: none;
}

.finance-calculator {
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
  padding: 1%;
}

.finance-calculator .finance-input .finance-button {
  width: 100%;
  background: #00a3d9;
  color: white;
  border-radius: 5px;
  padding: 0.7em;
  margin: 0px 0 12px;
}

.finance-calculator .finance-input button {
  background: transparent;
  border: none;
  color: #000000;
}

.second-card {
  border: none !important;
  padding: inherit;
}

.second-card .finance-card {
  display: flex;
  align-items: center;
  padding: 10px;
}

.finance-border-card {
  border: none;
}

.finance-card-input {
  text-align: center;
  border: none;
  outline: none;
  background: transparent;
}

.finance-card-label {
  font-weight: bold;
  text-align: center;
}

.finance-card-color {
  background: #f8f9fa;
  border-radius: 10px;
}

.finance-card input {
  border: none;
  outline: none;
  background: none;
  flex: 1;
  text-align: right;
}

.rupees-symbol {
  display: flex;
  font-size: 14px;
  color: #555;
  margin: 10px;
}

.finance-disclaim {
  color: #918d99;
  font-size: 14px;
}
</style>
